import TextOverrideStyleField from '@admin/components/mjson_designer/components/textstylefield'
import DividerStyleField from '@admin/components/mjson_designer/components/dividerstylefield'
import ResponsiveField from '@admin/components/mjson_designer/components/responsivefield'
import { normalizeConfig } from '../../../utils'
import Form from '@admin/components/form'
import * as styles from '../styles'
import settings from '../settings'
import PropTypes from 'prop-types'
import React from 'react'

const Text = (props) => <ResponsiveField { ...props } component={ TextOverrideStyleField } />

class EditQuoteBlock extends React.PureComponent {

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, theme, type } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { label: 't(Quote)', name: 'content.quote', type: 'textfield', required: true, value: config.content.quote },
                { label: 't(Speaker)', name: 'content.speaker', type: 'textfield', value: config.content.speaker }
              ]
            },
            {
              label: 't(Options)',
              fields: [
                { label: 't(Show)', name: 'content.show', type: 'checkboxgroup', options: [
                  { value: 'icon', text: 't(Icon)' },
                  { value: 'speaker', text: 't(Speaker)' }
                ], defaultValue: ['icon','speaker'], value: config.content.show }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 'Quote',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Divider)', name: 'styles.divider', collapsing: true, collapsed: true, type: DividerStyleField, theme, value: config.styles.divider },
                { label: 't(Quote Text)', name: 'styles.quoteText', collapsing: true, collapsed: true, type: Text, theme, value: config.styles.quoteText },
                { label: 't(Speaker Text)', name: 'styles.speakerText', collapsing: true, collapsed: true, type: Text, theme, value: config.styles.speakerText }
              ]
            },
            styles.BackgroundSection(config, device, theme, type),
            styles.BorderSection(config, device, theme, type),
            styles.SpacingSection(config, device, theme, type),
            styles.VisibilitySection(config, device, theme, type)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default EditQuoteBlock
